<template>
  <PanelCard v-if="visible" :title="I18n.t('user.panel.pulse_access_title')">
    <AccessList
      testid="user-panel-customer-roles"
      icon="heart-pulse"
      :label="I18n.t('user.panel.pulse_access_count', { count: items.length })"
      :empty-label="I18n.t('user.panel.no_pulse_added')"
      :items="items"
      :adding="{
        label: I18n.t('user.panel.add_pulse_portal'),
        placeholder: I18n.t('user.panel.search_pulse_portals'),
        search: searchPulsePortals,
      }"
      @add="store.addRole('customerRoles', $event)"
      @remove="store.removeRole('customerRoles', $event)"
    />
  </PanelCard>
</template>

<script setup lang="ts">
import type { AutocompleteOption } from '@app/application/user-management/types'

import { computed } from 'vue'

import { roleKinds } from '@app/application/user-management/types'
import { searchCompanies } from '@app/application/user-management/api/user-panel'
import {
  roleItems,
  useUserPanelStore,
} from '@app/application/user-management/stores/user-panel'
import useI18n from '@app/shared/vue/composables/use-I18n'
import AccessList from '@app/application/user-management/components/user-panel/access-list.vue'
import PanelCard from '@app/application/user-management/components/panel-card.vue'

defineOptions({ name: 'PulseAccessSection' })

const I18n = useI18n()
const store = useUserPanelStore()

// Staff and external users alike hold Pulse portals; an inactive user shows no
// permission section at all.
const visible = computed(() => store.user?.isActive ?? false)

const items = computed(() => roleItems(store.draft?.customerRoles ?? []))

const searchPulsePortals = (
  query: string,
  signal: AbortSignal
): Promise<AutocompleteOption[] | null> =>
  searchCompanies(store.openUserId, query, roleKinds.CUSTOMER, signal)
</script>
